import {CreateAnimal} from "@/api/animal";

const state = () => ({
    anilams: [],
    total: 0,
})

// getters
const getters = {}

const actions = {
    async CreateAnimal({dispatch}, params) {
        await dispatch("loading/setLoading", true, {root: true})
        CreateAnimal(params).then((data) => {
            console.log("createZone, data=", data)
        }).catch((err) => {
            console.log(err)
        }).finally(async () => {
            await dispatch("loading/setLoading", false, {root: true})
        })
    },
}

// mutations
const mutations = {
    setZones (state, anilams) {
        console.log("zones= ", anilams)
        state.anilams = anilams
    },
    setTotal (state, total) {
        state.total = total
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
